"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectToZendesk = redirectToZendesk;
const common_1 = require("../types/common");
const store_locale_1 = require("../utils/store-locale");
const ZENDESK_DEFAULT_URLS = {
    [common_1.Locale.EN]: 'https://service.grover.com/hc/en/requests/new',
    [common_1.Locale.DE]: 'https://service.grover.com/hc/de/requests/new',
    [common_1.Locale.NL]: 'https://service.grover.com/hc/nl/requests/new',
    [common_1.Locale.ES]: 'https://service.grover.com/hc/es/requests/new',
};
function redirectToZendesk(urls) {
    var _a;
    const { locale } = (0, store_locale_1.getStoreLocale)();
    const helpCenterUrl = (_a = urls === null || urls === void 0 ? void 0 : urls[locale]) !== null && _a !== void 0 ? _a : ZENDESK_DEFAULT_URLS[locale];
    if (helpCenterUrl) {
        window.open(helpCenterUrl, '_self');
    }
}
//# sourceMappingURL=index.js.map